import { render, staticRenderFns } from "./EmailCartModal.vue?vue&type=template&id=25574f03&scoped=true&"
import script from "./EmailCartModal.vue?vue&type=script&lang=js&"
export * from "./EmailCartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25574f03",
  null
  
)

export default component.exports